import { createSlice } from '@reduxjs/toolkit';

export interface IAlert {
  type: string;
  title: string;
  message: string;
  isVisible: boolean;
}

const initialState: IAlert = {
  type: '',
  title: '',
  message: '',
  isVisible: false,
};

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    showAlert: (state, action) => {
      const { type, title, message } = action.payload;
      state.type = type;
      state.title = title;
      state.message = message;
      state.isVisible = true;
    },
    hideAlert: (state) => {
      state.type = initialState.type;
      state.title = initialState.title;
      state.message = initialState.message;
      state.isVisible = initialState.isVisible;
    },
  },
});

export const { showAlert, hideAlert } = alertsSlice.actions;

export default alertsSlice.reducer;
